import {
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * Asset Name field definition
 * Free-text input (no preset values)
 */
export const AssetName: SimpleFilterDefinition = {
  apiField: 'name',
  uiField: 'Name',
  inputType: 'text',
  operators: ['is', 'is not', 'contains', 'starts with', 'ends with'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Name',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: queryFilter.value as string | string[],
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'name',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: simpleFilter.value,
    };
  },
};
